'use strict';
import $ from 'jquery';

//import setEnquire from 'enquire';
//setEnquire($);

export default class Menu {
	constructor() {
		if( $("nav").length > 0 ) {
			
			var $mobile = $(window).outerWidth() < 769;
			
			if($mobile){
				$('.mobile-menu').on('click', function(e){
					var $txt = $(this).find('span').text();
						
					$('.menu-holder').slideToggle();
					
					if ($txt == 'MENU'){
						$(this).find('span').text('CLOSE')
						$(this).find('img').attr('src', "/themes/custom/btbl/images/svg/icon-close.svg");
					} else {
						$(this).find('span').text('MENU')
						$(this).find('img').attr('src', "/themes/custom/btbl/images/svg/icon-multiWave.svg");
						//close everything
						$('.subMenu').slideUp();
						$('.Menu-item').removeClass('up');
					}
				});
				
				$('.menu_toggle').on('click', function(e){
					e.preventDefault;
					var $submenu = $(this).next('.subMenu'),
						$this = $(this);
					
					menu($submenu,$this);
				});
				
				$('.toggle .Menu-item_link').on('click', function(e){
					e.preventDefault;
					var $submenu = $(this).parent().find('.subMenu'),
						$this = $(this);
					
					menu($submenu,$this);
				});
				
				function menu($target, $this){
					if($target.is(':visible')){
						$target.slideUp();
						$this.parent().removeClass('up');
					} else {
						$('.up').removeClass('up');
						$('.subMenu:visible').hide();
						$target.slideDown();
						$this.parent().addClass('up');
					}
				}
			
			} 
		}
	}
}
